import { Route } from '@/Enums/Routes/Route.enum';
import NoDataCard from '@/components/NotFound/NoDataCard';
import { NEW_ITEM_ID } from '@/constants/campaignManagement';
import Button from '@mui/material/Button';
import { Link } from 'react-router-dom';

const NoResultsContent = () => {
  return (
    <>
      <div className='font-bold text-[38px] text-center'>No Results found</div>
      <div className='font-medium text-[20px] text-center'>We couldn’t find anything. Please refine your search or</div>
      <Link to={`${Route.CAMPAIGN_MANAGEMENT}/${NEW_ITEM_ID}`}>
        <Button variant='contained' className='!mt-4'>
          Create New Campaign
        </Button>
      </Link>
    </>
  );
};

const NoData = () => {
  return <NoDataCard renderContent={NoResultsContent} sx={{ margin: '0 1.75rem' }} />;
};

export default NoData;
